module.exports = (parcelRequire.load("3Dy6v")).then(() => parcelRequire('guoxr'));